import { routerIndex } from './routerIndex'
import { getParam } from "./getParam";


export const repeatedRequestIndex = () => {
  let url = '/ajax/state'
  const uid = getParam('uid')

  if (uid) {
    url += '?uid=' + uid
  }

  $.ajaxSetup({ cache: false })
  $.ajax({
    url: url,
    type: 'GET',
    success: function (response) {
      routerIndex(response.data)
    },
  })
}
